import { Flex } from "@chakra-ui/react";
import { ModalChangeUser } from "../modal-change-user";
import { Kanban } from "./kanban";
import { useAttendanceKanbanContext } from "./kanban/kanban-context";
import { AttendanceFilter } from "../attendance-filter";
import { ModalAgendar } from "../modal-agendar";
import { InputSearchNbCpf } from "./search-nb-cpf";
import { WhatsAppAttendances } from "../whatsapp-attendances";
import { NovoAttendanceModal } from "../new-attendance-modal";
import { ChatsContextProvider } from "../whatsapp-attendances/components/chats-context";
import { useApplicationContext } from "contexts/ApplicationContext";

export function KanbanAndTableAtendimento() {
  const { visualizationMode, attendanceFilter } = useAttendanceKanbanContext();
  const { user } = useApplicationContext();

  return (
    <>
      {visualizationMode === "kanban" ? (
        <Flex
          justifyContent="space-between"
          w="100%"
          borderBottom="1px solid #E8EAED"
          p="11px 30px 9px"
          mb="30px"
          gap="2"
        >
          <InputSearchNbCpf />
          <Flex alignItems="center">
            <AttendanceFilter />
          </Flex>
        </Flex>
      ) : null}
      <ChatsContextProvider>
        {visualizationMode === "kanban" ? (
          <>
            <Kanban />
            <NovoAttendanceModal />
          </>
        ) : visualizationMode === "whats-app-attendances" ? (
          <WhatsAppAttendances />
        ) : null}
        <ModalChangeUser />
      </ChatsContextProvider>
      <ModalAgendar />
    </>
  );
}
